module.exports = __webpack_public_path__ + "img/social2.f5c7984c.svg";